@if (!isDisabled) {
    <span
        class="odds-fav-icon"
        (click)="$event.preventDefault(); $event.stopPropagation(); add()"
        [ngClass]="{ 'fav-match': event?.eventSortCode === 'MTCH' }">
        <svg class="fav-icon-svg" data-crlat="favouriteIcon" [ngClass]="{ active: isFavourite }">
            <use xlink:href="#star"></use>
        </svg>
    </span>
}
